const getIntro = () => {
    return `    
    const AvatarMedal = ({ image, label, textPosition = "right" }) => {
    };
    export default AvatarMedal;
    `;
}

export default getIntro;
